const About = () => {
  const aboutList = [
    {
      img: "/images/about1.webp",
      txt1: "출장비\u00A0없는\u00A0출장견적",
      txt2: "오차없는\u00A0견적을\u00A0위해\u00A0바로\u00A0달려갑니다",
    },
    {
      img: "/images/about2.webp",
      txt1: "소독\u00A0및\u00A0방역절차\u00A0진행",
      txt2: "정리\u00A0후\u00A0발생할\u00A0수\u00A0있는\u00A0문제까지\u00A0해결합니다",
    },
    {
      img: "/images/about3.webp",
      txt1: "효율적인\u00A0작업\u00A0진행",
      txt2: "필요한\u00A0인원,\u00A0필요한\u00A0장비만\u00A0동원하여\u00A0작업합니다",
    },
    {
      img: "/images/about4.webp",
      txt1: "365일\u00A024시간\u00A0연중무휴",
      txt2: "언제라도\u00A0문의주시면\u00A0빠르게\u00A0달려갑니다",
    },
  ];
  return (
    <div
      id="about"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] xl:px-0 mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <div className="relative w-full h-fit flex justify-center items-end flex-nowrap sm:flex-wrap gap-3">
          <div className="relative w-fit h-full">
            <img
              className="!relative w-auto lg:w-full h-full max-h-9 lg:max-h-11 xl:max-h-14 lg:pb-1 object-contain"
              alt="비우고 채우고 로고"
              src="/images/logo.webp"
              loading="lazy"
              width={433}
              height={82}
            />
          </div>
          <h2 className="-mb-1.5 md:-mb-1">혜택 4가지</h2>
        </div>
        <p className="leading-tight lg:leading-normal text-base my-3 xl:my-5">
          -&nbsp;회사소개&nbsp;-
        </p>
        <p className="text-lg">
          곤란하고 힘들때 의지하고 맡기실 수 있도록, 비우고&nbsp;채우고에서
          약속드립니다.
        </p>
      </div>
      <div className="relative w-full h-fit xl:max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-5 lg:gap-6">
        {aboutList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full p-3 border rounded-3xl shadow-2xl"
          >
            <div className=" relative w-full h-fit mb-5 text-center text-black">
              <h3 className="glight mb-2">{v.txt1}</h3>
              <p className="text-sm">{v.txt2}</p>
            </div>
            <div className="relative w-full h-72 xl:h-80 rounded-3xl overflow-hidden">
              <img
                className="!relative w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                alt={`비우고 채우고 ${v.txt1}`}
                src={v.img}
                loading="lazy"
                width={414}
                height={506}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;
